import axios, { ApiResponse, getRequestError } from "../../utils/axios";
import { InquireDataErrors } from "./inquireData.error";

export type InquireDataRequest = {
  ad_id: string;
};
export type InquireDataResponse = {
  show_nps: boolean;
};

export const inquireData = (
  request: InquireDataRequest
): ApiResponse<InquireDataResponse, InquireDataErrors> => {
  return axios
    .post<InquireDataResponse>("/InquireData", request)
    .then((res) => ({
      response: res.data,
    }))
    .catch((error) => {
      return { error: getRequestError<InquireDataErrors>(error) };
    });
};
